(() => {
  const roots = document.querySelectorAll("[data-full-video]");
  if (!roots.length) return;

  roots.forEach((root) => {
    const media = root.querySelector(".full-video__media--has-video");
    const video = root.querySelector("[data-full-video-el]");
    const button = root.querySelector("[data-full-video-play]");
    if (!media || !video || !button) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    const setPlaying = (playing) => {
      media.classList.toggle("is-playing", playing);
      button.setAttribute("aria-label", playing ? "Pause video" : "Play video");
    };

    const reveal = () => {
      video.classList.add("is-ready");
    };

    const paintFrame = () => {
      reveal();
      if (video.currentTime > 0) return;
      try {
        video.currentTime = 0.001;
      } catch (error) {
        // Ignore seek errors before the media is ready enough.
      }
    };

    if (video.readyState >= 2) {
      paintFrame();
    } else {
      video.addEventListener("loadeddata", paintFrame, { once: true });
      video.addEventListener("canplay", reveal, { once: true });
    }

    const tryPlay = () => {
      video.muted = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          setPlaying(false);
        });
      }
    };

    const toggle = () => {
      if (video.paused || video.ended) {
        tryPlay();
      } else {
        video.pause();
      }
    };

    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggle();
    });

    media.addEventListener("click", (event) => {
      if (event.target.closest("[data-full-video-play]")) return;
      toggle();
    });

    video.addEventListener("play", () => {
      reveal();
      setPlaying(true);
    });
    video.addEventListener("playing", () => {
      reveal();
      setPlaying(true);
    });
    video.addEventListener("pause", () => setPlaying(false));
    video.addEventListener("ended", () => setPlaying(false));
  });
})();
